/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-no-bind */
// eslint-disable-next-line no-use-before-define
import React, { useEffect, useRef, useState } from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { PageHeader } from '@ant-design/pro-layout';
import { Button, Card, Col, Row, Spin } from 'antd';
import { getStoredAccessToken } from 'utils/localStorage';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store/combineReducers';

interface IProps {
  onClose: () => void;
}
function Agent({ onClose }: IProps) {
  const [token, setToken] = useState(getStoredAccessToken());
  const { vivalinkTheme } = useSelector(
    (state: ApplicationState) => state.session,
  );

  const { t } = useTranslation();
  const [iframeTimestamp, setIframeTimestamp] = useState(new Date().valueOf());
  const [currTimestamp, setCurrTimestamp] = useState(iframeTimestamp);
  const [iframeUrl, setIframeUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const chostRef = useRef<any>(null);
  const iframeRef = useRef(null);

  useEffect(() => {
    if (token) {
      setIframeUrl(
        `/agent-frontend/?token=${token}&timetamp=${iframeTimestamp}`,
      );
    }
  }, [token, iframeTimestamp]);

  chostRef.current = {
    currTimestamp,
  };

  useEffect(() => {
    const handleVisible = () => {
      if (document.visibilityState === 'visible') {
        console.log('页面被重新唤醒了！');
        if (
          new Date().valueOf() - chostRef?.current?.currTimestamp >
          7 * 60 * 1000
        ) {
          setIframeTimestamp(new Date().valueOf());
        }
      } else if (document.visibilityState === 'hidden') {
        console.log('页面被切换到后台了！');
        setCurrTimestamp(new Date().valueOf());
      }
    };

    document.addEventListener('visibilitychange', handleVisible);
    return () => {
      document.removeEventListener('visibilitychange', handleVisible);
    };
  }, []);

  return (
    <Spin spinning={loading}>
      <Card className="full-height-page with-header">
        <Row justify="space-between" align="middle" className="pageHeader">
          <Col span={24}>
            <div className="vivalink-title">
              <Button type="link" onClick={() => onClose()}>
                <ArrowLeftOutlined /> Back
              </Button>
              {t('ai.title')}
            </div>
          </Col>
          <Col
            span={24}
            style={{
              filter: vivalinkTheme === 'light' ? 'invert(0%)' : 'invert(100%)',
            }}
          >
            <iframe
              ref={iframeRef}
              src={iframeUrl}
              title="AI Agent"
              style={{
                width: '100%',
                height: 'calc(100vh - 164px)',
                border: 'none',
              }}
              onLoad={() => setLoading(false)}
              allow="clipboard-write; clipboard-read"
            />
          </Col>
        </Row>
      </Card>
    </Spin>
  );
}

export default Agent;
